import REQUEST from "@/utils/httpRequest.js";

//订单列表
export function getSaleOrderList(params) {
    return REQUEST({
        url: "/uoms/saleorder/list",
        method: "get",
        params
    });
} 
//订单列表
export function getSaleOrderListStatistic(params) {
    return REQUEST({
        url: "/uoms/saleorder/list/statistic",
        method: "get",
        params
    });
} 

//订单明细
export function getSaleOrderLineList(params) {
    return REQUEST({
        url: "/uoms/saleorderline/list",
        method: "get",
        params
    });
} 

//订单确认
export function saleOrderConfirm(data){
    return REQUEST({
        url: "/uoms/saleorder/confirm",
        method: "post",
        data
    });
}

//订单操作-通知客户确认
export function notifyCustomer(data){
    return REQUEST({
        url: "/uoms/saleorder/notify_customer",
        method: "post",
        data
    });
}

//订单操作-审核
export function saleOrderAudit(data){
    return REQUEST({
        url: "/uoms/saleorder/audit",
        method: "post",
        data
    });
}
//订单操作-采购-获取数据
export function saleOrderPrePurchase(data){
    return REQUEST({
        url: "/uoms/saleorder/pre_purchase",
        method: "post",
        data
    });
}

//订单操作-采购
export function saleOrderPurchase(data){
    return REQUEST({
        url: "/uoms/saleorder/purchase",
        method: "post",
        data
    });
}

//订单操作-通知发货数据
export function preNotifyDeliver(data){
    return REQUEST({
        url: "/uoms/saleorder/pre_notify_deliver",
        method: "post",
        data
    });
}


//订单操作-通知发货
export function notifyDeliver(data){
    return REQUEST({
        url: "/uoms/saleorder/notify_deliver",
        method: "post",
        data
    });
}

//订单操作-发货
export function saleOrderDeliver(data){
    return REQUEST({
        url: "/uoms/saleorder/deliver",
        method: "post",
        data
    });
}

//订单操作-申请开票
export function applyInvoice(data){
    return REQUEST({
        url: "/uoms/saleorder/apply_invoice1",
        method: "post",
        data
    });
}


//订单操作-申请开票数据
export function preApplyInvoice(data){
    return REQUEST({
        url: "/uoms/saleorder/pre_apply_invoice",
        method: "post",
        data
    });
}


//订单操作-申请异常开票提交
export function applyAbnormalInvoice(data){
    return REQUEST({
        url: "/uoms/saleorder/apply_abnormal_invoice",
        method: "post",
        data
    });
}

//订单操作-申请异常开票数据
export function preApplyAbnormalInvoice(data){
    return REQUEST({
        url: "/uoms/saleorder/pre_apply_abnormal_invoice",
        method: "post",
        data
    });
}

//订单操作-催款
export function urgingSave(data){
    return REQUEST({
        url: "/uoms/saleorder/urging",
        method: "post",
        data
    });  
}

//订单操作-拒收
export function saleOrderRejection(data){
    return REQUEST({
        url: "/uoms/saleorder/rejection",
        method: "post",
        data
    });  
}

//订单操作-质量售后
export function customerService(data){
    return REQUEST({
        url: "/uoms/saleorder/customer_service",
        method: "post",
        data
    });  
}

//订单操作-退货
export function saleOrderReturn(data){
    return REQUEST({
        url: "/uoms/saleorder/return",
        method: "post",
        data
    });  
}

//订单操作-换货
export function saleOrderExchange(data){
    return REQUEST({
        url: "/uoms/saleorder/exchange",
        method: "post",
        data
    });  
}

//订单操作-变更
export function saleOrderModify(data){
    return REQUEST({
        url: "/uoms/saleorder/modify",
        method: "post",
        data
    });  
}
//订单操作-取消订单 
export function saleOrderCancel(data){
    return REQUEST({
        url: "/uoms/saleorder/cancel",
        method: "post",
        data
    });  
}
//订单操作-提交
export function saleOrderSubmit(data){
    return REQUEST({
        url: "/uoms/saleorder/submit",
        method: "post",
        data
    });  
}


//订单明细操作-申请商务折扣
export function applyBusinessDiscount(data){
    return REQUEST({
        url: "/uoms/saleorderline/apply_business_discount",
        method: "post",
        data
    });  
}

//订单明细操作-解除在途
export function releaseInTransit(data){
    return REQUEST({
        url: "/uoms/saleorderline/release_in_transit",
        method: "post",
        data
    });  
}

//订单明细操作-行关闭
export function closeLine(data){
    return REQUEST({
        url: "/uoms/saleorderline/close_line",
        method: "post",
        data
    });  
}

//订单执行-首页执行图
export function reagentDashboard(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/dashboard",
        method: "get",
        params
    });  
}


//订单执行-试剂/设备-暂未采购
export function reagentMachineUnpurchased(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/unpurchased",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-漏采购
export function toPurchase(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/to_purchase",
        method: "get",
        params
    });  
}



//订单执行-试剂/设备-采购
export function reagentMachinePurchase(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/purchase",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-采购执行节点 弹窗
export function reagentMachinePurchaseNodeDetail(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/purchase_execute_node_detail",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-采购-厂家反馈/采购反馈(弹窗)
export function reagentMachinePurchaseFeekbackDetail(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/purchase_feekback_detail",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-入库
export function reagentMachineIn(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/in",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-发货
export function reagentMachineSend(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/send",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-签收
export function reagentMachineSign(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/sign",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-开票
export function reagentMachineInvoice(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/invoice",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-回款
export function reagentMachineGetMoney(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/get_money",
        method: "get",
        params
    });  
}

//订单执行-试剂/设备-完成
export function reagentMachineDone(params,type){
    return REQUEST({
        url: "/uoms/execute/"+type+"/done",
        method: "get",
        params
    });  
}

//发货地点
export function addressList(params){
    return REQUEST({
        url: "uoms/uoms.delivery.address/list",
        method: "get",
        params
    });  
}
//订单打印 客户版本-我司版本
export function onPdfUrl(data){
    return REQUEST({
        url: "/uoms/saleorder/get_pdf_url",
        method: "post",
        data
    });  
}
 
//售后申请-获取数据
export function getDeliveryDataBySell(data){
    return REQUEST({
        url: "uoms/get_delivery_data_by_sell", 
        method: "post",
        data
    });  
}

//售后申请-创建申请https://odootest.univ-bio.com/uoms/oms_create_sales_complainant
export function createSalesComplainant(data){
    return REQUEST({
        url: "uoms/oms_create_sales_complainant", 
        method: "post",
        data
    });  
}

//获取公司组织
export function companyList(data){
    return REQUEST({
        url: "uoms/company/list", 
        method: "post",
        data
    });  
}

//导入
export function importFile(data){
    return REQUEST({
        url: "uoms/sale/import", 
        method: "post",
        data
    });  
}


//搜索条件来源

export function originList(data){
    return REQUEST({
        url: "uoms/saleorder/origin_list", 
        method: "post",
        data
    });  
}
//商品搜索
export function productList(data){
    return REQUEST({
        url: "project/ucrm_product_list", 
        method: "post",
        data
    });
}


export function uploadOrderFile(data) {
    return REQUEST({
        url: "oms/upload_attachment",
        method: "post",
        data,
        headers: {
            "Content-type": "multipart/form-data"
        }
    });
}

//列表删除
export function onDelete(data) {
    return REQUEST({
        url: "uoms/saleorder/delete",
        method: "post",
        data
    });
}

//跟单列表
export function purchaseorderlist(params) {
    return REQUEST({
        url: "/uoms/purchaseorder/list",
        method: "get",
        params
    });
}
//发送跟单查询
export function findpurchaseorder(params) {
    return REQUEST({
        url: "/uoms/tracking/arrival",
        method: "get",
        params
    });
}

export function cancelpurchaseorder(params){
    return REQUEST({
        url: "/uoms/tracking/applycancel",
        method: "get",
        params
    });
}

//异常回复查询
export function getExceptionInfo(params){
    return REQUEST({
        url: "/uoms/tracking/exception/info",
        method: "get",
        params
    });
}

//异常回复查询提交
export function exceptionFeedback(data) {
    return REQUEST({
        url: "/uoms/tracking/exception/feedback",
        method: "post",
        data
    });
} 
//解除在途
export function occupation(params) {
    return REQUEST({
        url: "/uoms/tracking/release/occupation",
        method: "get",
        params
    });
} 


export function getNotifyDeliverBatch(data) {
    return REQUEST({
        url: "/uoms/saleorder_search/notify_deliver_batch",
        method: "post",
        data
    });
} 

export function getInformation(params) {
    return REQUEST({
        url: "/uoms/saleorder/tracking/waybill",
        method: "get",
        params
    });
} 
export function onArrival(params){
    return REQUEST({
        url: "/uoms/execution/tracking/arrival",
        method: "get",
        params
    });

}
export function belongs(data) {
    return REQUEST({
        url: "/uoms/saleorder/belongs",
        method: "post",
        data
    });
} 
export function onModifyCpg(data) {
    return REQUEST({
        url: "/uoms/saleorder/modify_cpg",
        method: "post",
        data
    });
} 
//获取销售组人员
export function groupPerson(data){
    return REQUEST({
        url: "/uoms/saleorder/group_person",
        method: "post",
        data
    });
}

//发送邮件人员信息
export function getSendEmailUser(data){
    return REQUEST({
        url: "/uoms/tracking/employee",
        method: "post",
        data
    });
}

//发送邮件
export function onSendEmail(data){
    return REQUEST({
        url: "/uoms/tracking/send_email",
        method: "post",
        data
    });
}
//获取用户信息
export function getEmployee(params){
    return REQUEST({
        url: "/uoms/saleorder/token_user",
        method: "get",
        params
    });

}
//获取用户信息
export function getServiceList(params){
    return REQUEST({
        url: "/uoms/purchaseorder/service/list",
        method: "get",
        params
    });
}

//获取四个品牌列表 乐备实 斯达特 爱必信 优宁维
export function getPrivateBrandList(params){
    return REQUEST({
        url: "/uoms/private/brand",
        method: "get",
        params
    });
}
//重点订单按钮
export function getImportant(params){
    return REQUEST({
        url: "/uoms/mark/purchase/important",
        method: "get",
        params
    });
}

//获取三个自有品牌厂家自主跟单 starter /absin / ua
export function getFactoryFollowList(params){
    return REQUEST({
        url: "/uoms/factory/follow",
        method: "get",
        params
    });
}
// absin组织间需求单跟单列表
export function getFactoryUnitFollowList(params){
    return REQUEST({
        url: "/uoms/factory/unit/follow",
        method: "get",
        params
    });
}
//三自有品牌回复查到货 或 主动跟单
export function reply(params){
    return REQUEST({
        url: "/uoms/factory/arrival/reply",
        method: "get",
        params
    });
}
// 组织间需求单回复查到货 或 主动跟单
export function unitReply(params){
    return REQUEST({
        url: "/uoms/factory/unit/arrival/reply",
        method: "get",
        params
    });
}
// 组织间需求单发起查到货
export function unitArrivalSend(params){
    return REQUEST({
        url: "/uoms/factory/unit/arrival/send",
        method: "get",
        params
    });
}

//获取自主品牌技术跟单
export function getSelfBrandList(params){
    return REQUEST({
        url: "/uoms/sale/follow/self/brand",
        method: "get",
        params
    });
}
//自主品牌技术跟单发送跟单查询
export function selfBrandArrivalOrder(params) {
    return REQUEST({
        url: "/uoms/sale/selfbrand/arrival",
        method: "get",
        params
    });
}
//导出
export function exportData(params) {
    return REQUEST({
        url: "/uoms/factory/tracking/export",
        method: "get",
        params
    });
}
export function factoryImport(data) {
    return REQUEST({
        url: "/uoms/factory/tracking/import",
        method: "post",
        data,
        headers: {
            "Content-type": "multipart/form-data"
        }
    });
}
export function factoryImportProductLine(params) {
    return REQUEST({
        url: "/tracking/purchase/factory/productline",
        method: "get",
        params
    });
}

export function selfBrandCancel(params){
    return REQUEST({
        url: "/uoms/sale/selfbrand/cancel",
        method: "get",
        params
    });
}
export function absinCommerceCancel(params){
    return REQUEST({
        url: "/uoms/sale/absin/commerce/cancel",
        method: "get",
        params
    });
}

export function absinCommerceInfo(params){
    return REQUEST({
        url: "/uoms/sale/absin/commerce/info",
        method: "get",
        params
    });
}

export function getStarterKitLine(params){
    return REQUEST({
        url: "/uoms/starter/kit/line",
        method: "get",
        params
    });
}
//自主品牌定制生产或服务取消
export function selfBrandCustomizationCancel(params){
    return REQUEST({
        url: "/uoms/sale/selfbrand/customization/cancel",
        method: "get",
        params
    });
}
//自主品牌技术跟单解除占用
export function selfBrandReleaseOccupation(params){
    return REQUEST({
        url: "/uoms/selfbrand/release/occupation",
        method: "get",
        params
    });
}





// WEBPACK FOOTER //
// ./src/api/order.js